// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"3093":"list","3180":"story","5177":"home"}[chunkId] || chunkId) + "-" + {"1861":"97347fb56f983721e5fb","3093":"41efa93974b30f573858","3180":"ad58af9f39514589cb32","5177":"9d49fab0f855f4406a7d","7019":"98a03b902de118bdaa9c","7776":"742ce56b19a6f92f8fe5","9387":"a7633077bd18684400c2"}[chunkId] + ".css";
};